import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { TutorClassDetailTemplate } from '@/features/tutor-ai';

export const Route = createFileRoute('/_authenticated/tutor-ai/classes/$classStudentId/')({
  validateSearch: z.object({
    /** Rótulo da turma carregado da listagem — a API não resolve id → nome. */
    label: z.string().optional(),
  }),
  component: TutorClassDetailPage,
});

/** Página do detalhe de uma turma no tutor. */
export function TutorClassDetailPage() {
  const { classStudentId } = Route.useParams();
  const { label } = Route.useSearch();

  // `label` pode chegar como string vazia (URL com `?label=`) — `??` só cobre
  // null/undefined, então o fallback usa string vazia explícita para o template decidir.
  return (
    <TutorClassDetailTemplate classStudentId={Number(classStudentId)} classLabel={label ?? ''} />
  );
}
